$(document).ready(function() {

	// Check page contains a map section
	if( $('.section-country-map').length ) {


		// Clicked map nav child item title
		$('.country-map-nav .child-item__title').click(function() {
			// console.log('111');

			// Get the parent map section
			const mapSection = $(this).closest('.section-country-map');

			// Get the value of the data-imp-trigger-object-on-mouseover attribute (eg 'Spot 1')
			const spotTitle = $(this).attr('data-imp-trigger-object-on-mouseover');

			// De-activate all spots
			$('.imp-object-spot').removeClass('js-active');

			// Get and activate the associated spot
			const spotElement = mapSection.find('[data-title="' + spotTitle + '"]');
			spotElement.addClass('js-active');

			// Get and activate the associated tooltip (desktop only)
			if ($(window).width() >= 1000) {
				const spotId = spotElement.attr('data-object-id');
				const tooltipElement = $('[data-tooltip-id="' + spotId + '"]');
				tooltipElement.addClass('js-active');
			}

			// Hide all content items
			$('.child-item__content').removeClass('js-active');

			// Show the associated content item
			const childItemContent = $(this).next('.child-item__content');
			childItemContent.addClass('js-active');
		});



		// Clicked map nav child item close
		$('.country-map-nav .child-item__content .icon-close').click(function() {

			// Hide the whole child content item
			const childItemContent = $(this).closest('.child-item__content');
			childItemContent.removeClass('js-active');

			// Get the parent map section and the name of the Map Image
			const mapSection = $(this).closest('.section-country-map');
			const mapImageName = mapSection.find('[data-image-map-name]').data('image-map-name');

			// Re-center the map
			// ImageMapPro.reInitMap(mapImageName);

			// Get the value of the data-imp-trigger-object-on-mouseover attribute
			const spotTitle = $(this).closest('.child-item').find('.child-item__title').attr('data-imp-trigger-object-on-mouseover');

			// Get and de-activate the associated spot
			const spotElement = mapSection.find('[data-title="' + spotTitle + '"]');
			spotElement.removeClass('js-active');

			// Get and de-activate the associated tooltip (desktop only)
			if ($(window).width() >= 1000) {
				const spotId = spotElement.attr('data-object-id');
				const tooltipElement = $('[data-tooltip-id="' + spotId + '"]');
				tooltipElement.removeClass('js-active');
			}

			// console.log(mapImageName);
			// console.log(spotTitle);

			ImageMapPro.hideTooltip(mapImageName, spotTitle)

		});


		// JavaScript Hooks
		ImageMapPro.subscribe((action) => {
			
			// When a spot is clicked, update the nav
			if (action.type === 'objectClick') {

				$('.section-country-map').find('.imp-object-spot').removeClass('js-active');
				$('.imp-tooltip').removeClass('js-active');
				$('.child-item__content').removeClass('js-active');

				$('.child-item__title[data-imp-trigger-object-on-mouseover="' + action.payload.object + '"]').click();

				// Scroll to the one that was clicked (mobile only)
				if ($(window).width() < 1000) {
					setTimeout(function() {
						$('html, body').animate({
							scrollTop: $('.child-item__title[data-imp-trigger-object-on-mouseover="' + action.payload.object + '"]').offset().top
						}, 1000);
					}, 1200); 
				}

			}


			// De-activate spots when artboard changes
			if (action.type === 'changeArtboard') {

				$('.section-map').find('.imp-object-spot').removeClass('js-active');
				$('.imp-tooltip').removeClass('js-active');

			}


			// Update tooltip position when map move (desktop only)
			if ($(window).width() >= 1000) {
				if (action.type === 'zoomPanUpdate') {

					var mapName = action.payload.map;
					var objectTitle =  $('.imp-object.js-active').data('title');

					// console.log(mapName + objectTitle);

					ImageMapPro.showTooltip(mapName, objectTitle)

				}
			}

		})


		// Nav accordion
		$('.parent-item').click(function() {

			$('.parent-item').removeClass('js-active');
			$(this).addClass('js-active');

		});

	}




});








